import { useRef } from "react";
import { motion, useInView, useReducedMotion } from "framer-motion";
import { cn } from "@/lib/utils";

const SPINS = 2;
const ROWS = Array.from({ length: SPINS * 10 + 10 }, (_, i) => i % 10);

function SpinDigit({ d, delay, go, reduce }) {
  const target = `-${SPINS * 10 + d}em`;
  return (
    <span className="inline-block h-[1em] overflow-hidden align-top" aria-hidden="true">
      <motion.span className="flex flex-col leading-none" initial={{ y: reduce ? target : "0em" }} animate={{ y: go ? target : "0em" }}
        transition={{ duration: 2.1, ease: [0.16, 1, 0.3, 1], delay }}>
        {ROWS.map((n, i) => <span key={i} className="block h-[1em]">{n}</span>)}
      </motion.span>
    </span>
  );
}

// Odometer that spins through the digits and lands on the stat when it scrolls into view.
export function SpinStat({ value, className, ...rest }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-12% 0px" });
  const reduce = useReducedMotion();
  const chars = value.split("");
  let digitIndex = 0;
  return (
    <span ref={ref} className={cn("num inline-flex items-start", className)} style={{ lineHeight: 1 }} role="img" aria-label={value} data-value={value} {...rest}>
      {chars.map((ch, i) => {
        if (!/\d/.test(ch)) return <span key={i} className="inline-block h-[1em] leading-none" aria-hidden="true">{ch}</span>;
        const delay = 0.15 + digitIndex * 0.18;
        digitIndex += 1;
        return <SpinDigit key={i} d={Number(ch)} delay={delay} go={inView} reduce={!!reduce} />;
      })}
    </span>
  );
}
